export const AnswerTypes = {
	Radio: 'radio',
	Input: 'input',
	Select: 'select',
	Country: 'country',
	Checkbox: 'checkbox',
	Multiply: 'multiply',
	Numeric: 'numeric',
	Title: 'title',
	Age: 'age',
	Months: 'months',
	Plants: 'plants',
	Dimensions: 'dimensions'
};

export function Answer( title = '', chain = null, type, options ) {
	return {
		title,
		chain,
		type,
		options,
	};
}

class Step {
	constructor( id, title, type, answers, steps ) {
		this.id = id;
		this.title = title;
		this.type = type;
		this.answers = answers;
	}
	
	getChain( answer ) {
		return this.answers[answer].chain;
	}
}

export class SingleVariantStep extends Step {
	getChain( answer ) {
		return this.id + 1;
	}
}

export class RadioButtonStep extends Step {
	getChain( answer ) {
		return this.answers[answer].chain;
	}
}

export class CheckboxStep extends Step {
	getChain( answer ) {
		return this.id + 1;
	}
}

export class GroupStep extends Step {
	getChain( answer, steps ) {
		return this.id + 1;
	}
}

export function Option( label, value ) {
	return {
		label,
		value
	};
}



// WEBPACK FOOTER //
// ./src/model/index.js